import React, { useState } from "react";

export default function MissingInfoForm({ missingFields, onSubmit }) {
  const [formData, setFormData] = useState(
    missingFields.reduce((acc, f) => {
      acc[f.key] = "";
      return acc;
    }, {})
  );

  const handleChange = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div
      style={{
        background: "#fffaf2",
        padding: "20px",
        borderRadius: "8px",
        border: "1px dashed #e0b97d",
        marginTop: "10px"
      }}
    >
      <form onSubmit={handleSubmit}>
        {missingFields.map((field) => (
          <div key={field.key} style={{ marginBottom: "14px" }}>
            <label style={{ fontWeight: "bold" }}>
              {field.label}
              {field.reason && (
                <span style={{ color: "red", marginLeft: "8px", fontSize: "12px" }}>
                  ({field.reason})
                </span>
              )}
            </label>

            <input
              type="text"
              value={formData[field.key]}
              onChange={(e) => handleChange(field.key, e.target.value)}
              placeholder={field.label}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                marginTop: "4px"
              }}
            />
          </div>
        ))}

        <button
          type="submit"
          style={{
            background: "#6d28d9",
            color: "white",
            padding: "10px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer"
          }}
        >
          Submit Info
        </button>
      </form>
    </div>
  );
}
